module.exports = __webpack_public_path__ + "static/media/1.101c6111.jpg";